export const DefaultMonthsColumns = {
    enero: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    febrero: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    marzo: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    abril: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    mayo: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    junio: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    julio: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    agosto: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    septiembre: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    octubre: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    noviembre: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
    diciembre: {
        KgSecos: 0,
        CostoKgSec: 0,
    },
}
